import Vue from 'vue';
import collectBrowserInfo from '../utils/3dsv2helper';

// eslint-disable-next-line
export class PaymentService {
    static state(token, portal) {
        return Vue.http.get(`${portal}/payment/${token}/continue`);
    }
    static async stateToken(token, portal) {
        return Vue.http.get(`${portal}/payment/${token}/continue`);
    }
    static start(token, params, portal) {
        return Vue.http.post(`${portal}/payment/${token}/start`, params);
    }

    static threedsV2prepare(token, portal) {
        const params = collectBrowserInfo();
        return Vue.http.post(`${portal}/payment/${token}/3ds2-prepare/accept`, params);
    }

    static getToken(portal) {
        return Vue.http.post(`${portal}/token`);
    }

    static decline(token, portal) {
        return Vue.http.post(`${portal}/payment/${token}/decline`);
    }

    static accept(token, portal) {
        return Vue.http.post(`${portal}/payment/${token}/accept`);
    }

    static authConfirm(token, params, portal) {
        return Vue.http.post(`${portal}/payment/${token}/authentication-confirm`, params);
    }

    static authDecline(token, portal) {
        return Vue.http.post(`${portal}/payment/${token}/authentication-decline`);
    }

    static authRepeat(token, portal) {
        return Vue.http.post(`${portal}/payment/${token}/authentication-repeat`);
    }
}
